import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
gap: 1rem;
flex-wrap: wrap;
justify-content: center;
align-items: center;
`;